<template>
    <div>
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"
                 color="#00F">
        </loading>
        <vue-snotify></vue-snotify>
        <b-row class="animated fadeIn">
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-row class="card-margin">
                    <div class="card">
                        <div class="card-body card-body-wizard">
                            <ValidationObserver ref="all_form_wizard" v-bind:error_tab_info="all_errors">
                                <form-wizard
                                    ref="wizard"
                                    @on-complete="onComplete"
                                    shape="tab"
                                    color="#044066"
                                    class="wizard-margin"
                                    :finish-button-text="signature_btn_txt">

                                <template slot="step" scope="props">
                                    <wizard-step
                                            :tab="props.tab"
                                            :transition="props.transition"
                                            :key="props.tab.title"
                                            :index="props.index"
                                    ></wizard-step>
                                </template>
                                <!-- Tab 1 - Customer Details -->
                                <tab-content title="Customer Details" icon="ti ti-user" :before-change="validateCustomerStepForm">
                                    <ValidationObserver ref="customer">
                                        <Customer v-bind:error_tab_customer="customer_errors"/>
                                    </ValidationObserver>
                                </tab-content>
                                <!-- Tab 2 - Vehicle Details -->
                                <tab-content title="Vehicle Details" icon="ti ti-car" :before-change="validateVehicleStepForm">
                                    <ValidationObserver ref="vehicle">
                                        <Vehicle/>
                                    </ValidationObserver>
                                </tab-content>
                                <!-- Tab 3 - Cover Details -->
                                <tab-content title="Cover Details" icon="ti ti-shield" :before-change="validateCoverStepForm">
                                    <ValidationObserver ref="cover">
                                        <Cover/>
                                    </ValidationObserver>
                                </tab-content>
                                <!-- Tab 4 - Summary -->
                                <tab-content title="Summary" icon="ti ti-receipt">
                                    <!-- START - SUMMARY AGREE MODEL BOX -->

                                    <!-- END - SUMMARY AGREE MODEL BOX -->
                                    <FinalDocumentUpload/>
<!--                                    <hr/>-->
<!--                                    <button class="btn btn-warning" @click="preview()">Preview Prosal</button>-->
<!--                                    <hr/>-->
<!--                                    <Signature/>-->
                                </tab-content>

                                <template slot="footer" scope="props">


                                            <div class="wizard-footer-left">
                                                <wizard-button
                                                        v-if="props.activeTabIndex > 0" v-show="proposal_status != 5"
                                                        :style="props.fillButtonStyle"
                                                        @click.native="props.prevTab()"
                                                >Back
                                                </wizard-button>
                                                <wizard-button
                                                        v-if="props.activeTabIndex == 0"
                                                        :style="props.fillButtonStyle"
                                                        @click.native="backToMainDetails()"
                                                >Back To Main Details
                                                </wizard-button>
                                            </div>
                                            <div class="wizard-footer-right">

                                                <wizard-button
                                                        v-if="!props.isLastStep"
                                                        @click.native="props.nextTab();scrollToTop();"
                                                        class="wizard-footer-right"
                                                        :style="props.fillButtonStyle"
                                                >Next
                                                </wizard-button>

                                                <b-button
                                                    v-if="!props.isLastStep"
                                                    @click="transferToAgent()"
                                                    class="btn btn-success trnsfer-btn"
                                                >Transfer To Agent
                                                </b-button>


                                                <wizard-button
                                                        v-else
                                                        @click.native="onComplete()"
                                                        class="wizard-footer-right finish-button"
                                                        :style="props.fillButtonStyle"
                                                >
                                                    {{
                                                    props.isLastStep ? signature_btn_txt : "Next"
                                                    }}
                                                </wizard-button>
                                            </div>


                                </template>
                            </form-wizard>
                            </ValidationObserver>
                        </div>
                    </div>
                </b-row>
            </b-col>
        </b-row>

        <b-modal
                id="modal-proposal-agree"
                scrollable
                size="lg"
                title="Verify Proposal Information"
                centered
        >
            <Summary @enable_edit="allow_edit($event)"/>
            <Signature/>
            <SummaryTabButtonsCustomer/>

            <br>
        </b-modal>
    </div>
</template>

<script>
    //local registration
    import {mapState, mapActions} from "vuex";
    import {
        FormWizard,
        TabContent,
        WizardStep,
        WizardButton
    } from "vue-form-wizard";
    import "vue-form-wizard/dist/vue-form-wizard.min.css";

    import Customer from "@/components/frontend/registered/wizardtabs/Customer";
    import Vehicle from "@/components/frontend/registered/wizardtabs/Vehicle";
    import Cover from "@/components/frontend/registered/wizardtabs/Cover";
    import Summary from "@/components/frontend/registered/wizardtabs/Summary";
    import FinalDocumentUpload from "@/components/frontend/registered/wizardtabs/FinalDocumentUpload";
    import Signature from "./wizardtabs/Signature";
    import SummaryTabButtons from "./wizardtabs/SummaryTabButtons";
    import SummaryTabButtonsCustomer from "./wizardtabs/SummaryTabButtonsCustomer";

    export default {
        name: "WizardHolder",
        components: {
            SummaryTabButtonsCustomer,
            SummaryTabButtons,
            FormWizard,
            TabContent,
            Customer,
            Vehicle,
            Cover,
            Summary,
            WizardStep,
            WizardButton,
            FinalDocumentUpload,
            Signature,
        },
        data() {
            return {
                signature_btn_txt: 'Preview',
                isLoading: false,
                fullPage: true
            };
        },
        computed: {
            ...mapState("proposal", ["customer_errors", "back", "ActionData", "CustomerData","is_signature_step","proposal_status" , "all_errors" , "proposal_id" , "VehicleData"]),
            ...mapState("login", [
                "access_token",
            ]),
        },
        methods: {
            ...mapActions("proposal", [
                "draftProposalData",
                "saveProposalData",
                "getProposalData",
                "setProposalId",
                "setSignatureStep",
                "validateCustomerStep",
                "validateVehicleStep",
                "validateCoverStep",
                "getCoverList",
                "draftCoverData",
                "setCoverList",
                "proposalTransferToAgent",
                "getParameterDataList",
                "getMakeYearList",
                "getExtraFittings",
                "getConfigValues",
                "loadUploadedFiles",
                "getUploadTypes",
            ]),
            ...mapActions("login", [
                "getGuestToken"
            ]),
            onComplete: function () {
                this.$bvModal.show("modal-proposal-agree");
            },
            preview() {
                this.$bvModal.show("modal-proposal-agree");
            },
            agreeOk() {
                this.$bvModal.hide("modal-proposal-agree");
                this.$set(this.ActionData, "summary_confirm", true);
            },
            backToMainDetails() {
                if (this.ActionData.customer_form && this.$route.query.id && this.$route.query.uuid) {
                    this.$router.push({
                        name: 'ProposalEditCustomer', query: {
                            id: this.$route.query.id,
                            uuid: this.$route.query.uuid,
                            is_final: this.$route.query.is_final
                        }
                    })
                }
                if (!this.ActionData.customer_form && this.$route.query.id) {
                    this.$router.push({
                        name: 'ProposalEdit', query: {
                            id: this.$route.query.id,
                            is_final: this.$route.query.is_final
                        }
                    })
                }
            },
            validateCustomerStepForm() {
                this.isLoading = true;
                return new Promise((resolve, reject) => {
                    this.$refs.customer.validate().then((valid) => {
                        this.$snotify.clear();
                        if (valid) {
                            this.validateCustomerStep().then((response) => {
                                if (response.data.errors) {
                                    reject(valid);
                                    this.$snotify.error(response.data.errors.message, "", {
                                        position: "centerTop",
                                    });
                                } else {
                                    resolve(valid);
                                }
                                this.isLoading = false;
                            });
                        } else {
                            this.$snotify.error("Parameters related errors", "", {
                                position: "centerTop",
                            });
                            this.isLoading = false;
                        }

                    });
                });
            },
            validateVehicleStepForm() {
                this.isLoading = true;

                return new Promise((resolve, reject) => {
                    this.$refs.vehicle.validate().then((valid) => {
                        this.validateVehicleStep().then((response) => {
                            if (response.data.errors) {
                                reject(false);
                                this.$snotify.error(response.data.errors.message, "", {
                                    position: "centerTop",
                                });
                            } else {

                                this.getCoverList().then((response) => {
                                    this.setCoverList(response.data).then(() => {
                                        this.draftCoverData().then(() => {
                                            resolve(true);
                                        });
                                    });
                                });
                            }
                            this.isLoading = false;
                        });
                    });
                });
            },
            validateCoverStepForm() {
                this.isLoading = true;
                return new Promise((resolve, reject) => {
                    this.$refs.cover.validate().then((valid) => {
                        this.$snotify.clear();
                        if (valid) {
                            this.validateCoverStep().then((response) => {
                                this.isLoading = false;
                                if (response.data.errors) {
                                    this.$snotify.error(response.data.errors.message, "", {
                                        position: "centerTop",
                                    });
                                    reject(valid);
                                } else {
                                    resolve(valid);
                                }

                            });
                        } else {
                            this.isLoading = false;
                            this.$snotify.error("Please correct your form errors before proceed", "", {
                                position: "centerTop",
                            });
                            reject(valid);
                        }
                    });
                });
            },
            transferToAgent() {
              this.$confirm("Are you sure want to transfer this proposal to agent?").then(() => {
                this.isLoading = true;
                let data = {
                  proposal_id: this.proposal_id
                };
                this.proposalTransferToAgent(data).then((response) => {
                  if (!response.error) {
                    this.$snotify
                        .success(response.data.message, "", {
                          position: "centerTop",
                        }).on("destroyed", () => {
                      this.$router.push({
                        name: "ProposalListCustomer",
                        query: {
                          uuid: this.$route.query.uuid
                        }
                      })
                    });
                  }
                  this.isLoading = false;
                });
              });
            },
            parseJwt(token) {
                var base64Url = token.split(".")[1];
                var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                var jsonPayload = decodeURIComponent(
                    atob(base64)
                        .split("")
                        .map(function(c) {
                            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                        })
                        .join("")
                );

                return jsonPayload;
            },

            async getInsCmpList() {
                let table = 'param_finance_companies';
                const data = {
                    table: table,
                    type: 'insurance_cmp_list'
                };
                await this.getParameterDataList(data);
            },
            async getCityList() {
                let table = 'param_city';
                const data = {
                    table: table,
                    type: 'city_list'
                };
                await this.getParameterDataList(data);
            },
            async getVehicleDrivenByList() {
                let table = 'param_vehicle_driven_by';
                const data = {
                    table: table,
                    type: 'vehicle_driven_by_list'
                };
                await this.getParameterDataList(data);
            },
            async getVehicleTypeList() {
                let table = 'param_vehicle_class';
                const data = {
                    table: table,
                    type: 'vehicle_type_list'
                };
                await this.getParameterDataList(data);
            },
            async getVehicleUsageList() {
                let table = 'param_vehicle_usage';
                const data = {
                    table: table,
                    type: 'vehicle_usage_list',
                    extra_params: [{"vehicle_type": this.VehicleData.vehicle_type , "logic_type" : 1}]
                };
                await this.getParameterDataList(data);
            },
            async getFuelTypeList() {
                let table = 'param_fuel_types';
                const data = {
                    table: table,
                    type: 'fuel_type_list'
                };
                await this.getParameterDataList(data);
            },
            async getVehicleMakeList() {
                let table = 'param_vehicle_make';
                const data = {
                    table: table,
                    type: 'vehicle_make_list'
                };
                await this.getParameterDataList(data);
            },
            async getVehicleModelList() {
                let table = 'param_vehicle_model';
                const data = {
                    table: table,
                    type: 'vehicle_model_list',
                    where: [{"field": "make_id", "operator": "=", "value": this.VehicleData.vehicle_make}]
                };
                await this.getParameterDataList(data);
            },
            async getCoverTypeList() {
                let table = 'param_cover_type';
                const data = {
                    table: table,
                    type: 'cover_type_list'
                };
                await this.getParameterDataList(data);
            },
            async getTitleList() {
              let table = 'param_titles';
              const data = {
                table: table,
                type: 'title_list'
              };
              await this.getParameterDataList(data);
            },
            async getVehicleNoFormatList() {
              let table = 'param_vehicle_no_formats';
              const data = {
                table: table,
                type: 'vehicle_no_format_list'
              };
              await this.getParameterDataList(data);
            },
            scrollToTop() {
              let content = document.querySelector(".app-body");
              content.scrollTo(0,0);
            }
        },

        mounted() {
            this.isLoading = true;

            if(this.$route.query.uuid){
                this.isLoading = true;

                /*Logged customer user as guest user*/
                let obj = {};
                obj.uuid = this.$route.query.uuid;
                this.getGuestToken(obj).then((response) => {
                    if (!response.error) {
                        if (this.access_token === null) {

                        } else {
                            /*set user permissions*/
                            let perm = [];
                            let payload = JSON.parse(this.parseJwt(this.access_token));
                            payload.scopes.forEach((value, index) => {
                                let obj = {};
                                obj.actions = value;
                                obj.subject = "all";
                                perm.push(obj);
                            });
                            this.$ability.update(perm);

                            /*Main Page Related*/
                            this.getTitleList();
                            this.getVehicleNoFormatList();

                            /*Customer Related dropdown data*/
                            this.getInsCmpList();
                            this.getCityList();
                            this.getVehicleDrivenByList();

                            /*VehicleRelated dropdownd data*/
                            this.getVehicleTypeList();
                            this.getVehicleUsageList();
                            this.getFuelTypeList();
                            this.getVehicleMakeList();
                            this.getVehicleModelList();
                            this.getMakeYearList();
                            if (this.$route.query.id) {
                                const data = {
                                    proposal_id_hash: this.$route.query.id
                                };
                                this.getExtraFittings(data);
                            }

                            /*Cover Related Data*/
                            this.getCoverTypeList();
                            this.getConfigValues();

                            /*File Upload Data*/
                            this.getUploadTypes();
                            if (this.$route.query.id) {
                                let payload = {
                                    proposal_id: this.$route.query.id
                                };
                                this.loadUploadedFiles(payload);
                            }


                            if (this.$route.query.id) {
                                const data = {
                                    proposal_id: this.$route.query.id,
                                    uuid: this.$route.query.uuid
                                };
                                this.getProposalData(data).then((response) => {
                                    if (!response.error) {

                                        this.getCoverList().then((response) => {
                                            this.$snotify.clear();
                                            if (response.data.errors) {
                                                // this.$snotify
                                                //     .error(response.data.errors.message, "", {
                                                //         position: "centerTop",
                                                //     }).on("destroyed", () => {
                                                //     this.draftCoverData();
                                                // });
                                              this.draftCoverData();
                                            } else {
                                                this.setCoverList(response.data).then(() => {
                                                    this.draftCoverData();
                                                });
                                            }
                                        });

                                        if (response.data.data.proposal_status == 5) {
                                            this.signature_btn_txt = 'Preview and sign';
                                            this.$refs.wizard.changeTab(0, 3);
                                            this.setSignatureStep(true);
                                        }else{
                                          this.$refs.wizard.changeTab(0,response.data.data.last_completed_step);
                                        }

                                        if( [1,6,7,8,9,10,11,12].indexOf(response.data.data.proposal_status) >= 0 ){
                                          // this.$router.push({
                                          //   name: 'PublicAccessDenied'
                                          // });
                                          this.$router.push({
                                            name: 'ProposalListCustomer',
                                            query: { uuid: this.$route.query.uuid }
                                          });
                                        }

                                    }
                                    this.isLoading = false;
                                });
                            }else{
                                this.isLoading = false;
                            }
                        }

                    }else{
                        this.isLoading = false;
                    }

                });
            }

        },
        created() {

        },
        watch: {
            all_errors: function () {
                if (this.all_errors) {
                    console.log(this.all_errors);
                    this.$refs.all_form_wizard.setErrors(this.all_errors);
                }
            },
        }
    };
</script>


<style scoped>
    .trnsfer-btn{
        margin-right: 5px;
    }

    .row {
        display: block !important;
    }

    .custom-select {
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
    }

    .small-text {
        color: #73818f;
    }

    .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 0px solid #308ee0 !important;
        border-radius: 0.25rem;
    }

    div.card {
        border: 0;
        margin-bottom: 30px;
        margin-top: 30px;
        border-radius: 6px;
        color: rgba(0, 0, 0, 0.87);
        background: #fff;
        width: 100%;
        box-shadow: 0 2px 10px 0 rgba(33, 150, 243, 0.08),
        0 3px 1px -4px rgba(142, 204, 253, 0.34),
        0 1px 30px 0 rgba(33, 150, 243, 0.11);
    }

    .div.card .card-body {
        padding: 15px 30px;
    }

    .card-margin {
        margin-top: 0;
    }

    .top-margin {
        margin-top: 85px;
    }

    .card-body-wizard {
        margin-bottom: -20px;
    }

    .header-color {
        color: #34627d;
    }

    .header-alignmet {
        text-align: center;
    }

    .paragraph {
        color: #4e4e4e;
        margin-top: -8px;
    }

    .app-footer {
        bottom: 0 !important;
        position: absolute;
        width: 100%;
    }

    .wizard-margin {
        margin-top: 10px;
    }

    .modal-header{
        border-bottom: 0px solid !important;
        background-color: #f0f3f5 !important;
    }

    @media (max-width: 768px) {
        .app-footer {
            display: unset !important;
            text-align: center !important;
            bottom: 0 !important;
            position: absolute;
            width: 100%;
        }

        .top-margin {
            margin-top: 75px;
        }

        div.card {
            margin-left: 10px;
            margin-right: 10px;
        }
    }
</style>